import * as yup from 'yup';

import { VERSICHERUNGSART } from '@/features/Sparten/shared/types';

export const allgemeinKfzSchema = yup.object({
  versicherungsartSelection: yup
    .string()
    .default(VERSICHERUNGSART.VERSICHERER_TARIF_WECHSEL),
  versicherungsart: yup.string().default(''),
});

export type AllgemeinKfzSchema = yup.Asserts<typeof allgemeinKfzSchema>;
